var map = {
	"./inverno/brilhante/cor.jpeg": 628,
	"./inverno/escuro/cor.jpeg": 629,
	"./inverno/frio/cor.jpeg": 630,
	"./outono/escuro/cor.jpeg": 631,
	"./outono/quente/cor.jpeg": 632,
	"./outono/suave/cor.jpeg": 633,
	"./primavera/brilhante/cor.jpeg": 634,
	"./primavera/clara/cor.jpeg": 635,
	"./primavera/quente/cor.jpeg": 636,
	"./verao/claro/cor.jpeg": 637,
	"./verao/frio/cor.jpeg": 638,
	"./verao/suave/cor.jpeg": 639
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 627;